import { _ as o } from "./index.es502.js";
var r = o,
  a = r.Symbol,
  t = a;
export { t as _ };